import { render, staticRenderFns } from "./TrayWrapper.vue?vue&type=template&id=e7217240"
import script from "./TrayWrapper.vue?vue&type=script&lang=js"
export * from "./TrayWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports